import './SystemRecoveryCommand.css';

const SystemRecoveryCommand = () => {
  return (
    <div className="system-recovery-command-container page-container">
    </div>
  );
};

export default SystemRecoveryCommand;
